import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import ReactWaves from '@dschoon/react-waves';
//import FastAverageColor from 'fast-average-color';
import global from '../../stores/GlobalStore';
import MultiClamp from 'react-multi-clamp';
import history from '../../auth/history';

import { getQueryParamNoHash } from '../../utils/http';
import { normalizeNavigatorData } from '../../utils/browserUtils';
import clippIcon from '../Home/styles/clippsIcon-black.png';
import { formatDuration, getFakePeaks, calculateZoom } from '../../utils/podcastUtils';
import LoadingSpinner from '../Shared/LoadingSpinner';

import './styles/EmbedPlayer.scss';

export default class EmbedPlayer extends React.Component {
  constructor(props) {
    super(props);

    this.audioPeaks = this.getAudioPeaks();

    this.startTime = getQueryParamNoHash('start') || getQueryParamNoHash('s');
    this.endTime = getQueryParamNoHash('end') || getQueryParamNoHash('e');
    this.state = this.getInitialState(this.props);

    this.audioRef = React.createRef();
  }

  componentDidMount() {
    window.addEventListener('TOGGLE_AUDIO', this.toggleAudio);

    if (!_.size(this.props.episode)) {
      const episodeId = getQueryParamNoHash('id');
      global()
        .getPodcastStore()
        .fetchEpisode(episodeId, episode => {
          this.fetchShow(episode.showId);
          this.setState({ episode, embed: true });
        });
    } else {
      this.fetchShow(this.props.episode.showId);
      this.setState({ episode: this.props.episode, embed: false });
    }

    setTimeout(() => {
      this.setState({ isLoading: false });
    }, 2000);
  }

  componentWillUnmount() {
    window.addEventListener('TOGGLE_AUDIO', this.toggleAudio);
    this.setState({ isLoading: false, wavesurfer: null });
  }

  fetchShow = showId => {
    global()
      .getPodcastStore()
      .fetchShow(showId, false, show => {
        this.setState({ show });
      });
  };

  componentWillReceiveProps(newProps) {
    if (newProps.episode && this.props.episode.id !== newProps.episode.id) {
      this.setState({ requestUpdate: true });
    }
  }

  componentDidCatch(error, info) {}

  getInitialState = props => {
    let currentTime = 0;

    if (props.episode.progress && props.episode.progress.length && props.episode.progress[0].episodeData) {
      currentTime = props.episode.progress[0].episodeData.position;
    } else if (this.startTime) {
      currentTime = parseInt(this.startTime);
    }

    return {
      episode: props.episode,
      show: props.show,
      wavesurfer: null,
      totalDuration: props.episode.duration,
      pos: currentTime,
      isLoading: true,
      inApp: true, // Determines if collapse button is visible
      isPlaying: false,
      embedded: true,
      requestUpdate: false,
      currentFormatTime: formatDuration(currentTime, true),
      color: {
        hex: props.options.btnColor,
      },
    };
  };

  updateCurrentEpisode = () => {
    this.setState(this.getInitialState(this.props), () => {
      this.fetchShow(this.props.episode.showId);
      setTimeout(() => {
        this.setState({ isLoading: false });
      }, 1500);
    });
  };

  renderUpdateAudioQuestion = () => {
    return (
      <div className='update-audio-question'>
        <div>Play new episode?</div>
        <div className='question' onClick={this.updateCurrentEpisode}>
          Yes
        </div>
        <div
          className='question'
          onClick={() => {
            this.setState({ requestUpdate: false });
          }}
        >
          No
        </div>
      </div>
    );
  };

  recordListenEvent = (user, duration, position) => {
    const { isPlaying } = this.state;

    if (isPlaying) {
      const percentage = (position / duration) * 100;
      const clientDetails = window.navigator;
      const episodeId = this.state.episode.id;
      const showId = this.state.show.id;
      const browserData = normalizeNavigatorData(clientDetails);

      if (duration && position) {
        if (_.size(user)) {
          // console.log(`${user.id} started listening to ${episodeId} of the show ${showId} at ${position} of ${duration}, equaling ${Math.round(percentage)}%`);

          const episodeData = {
            position,
            duration: Math.round(duration),
            percentage: Math.round(percentage),
          };

          global()
            .getPodcastStore()
            .recordEpisodeListen(
              {
                userId: user.id,
                showId,
                episodeId,
                browserData,
                episodeData,
              },
              result => {
                // console.log(result);
              }
            );
        } else {
          // console.log(`Clipps: Anonymous Listen`);
          global()
            .getPodcastStore()
            .recordEpisodeListen(
              {
                userId: user.id,
                showId,
                episodeId,
                browserData,
                episodeData: {},
              },
              result => {
                // console.log(result);
              }
            );
        }
      }

      return isPlaying;
    }
  };

  toggleAudio = () => {
    const isPlaying = !_.clone(this.state.isPlaying);

    this.props.setEpisodeState(isPlaying);
    this.setState({ isPlaying }, () => {
      if (this.audioRef.audioEl && this.audioRef.audioEl.play && isPlaying) {
        //let audio = document.getElementById('react-audio-player');
        this.audioRef.audioEl.play();
      } else if (this.audioRef.audioEl && this.audioRef.audioEl.play && !isPlaying) {
        this.audioRef.audioEl.pause();
      } else if (isPlaying) {
        setTimeout(() => {
          const duration = this.state.wavesurfer && _.clone(this.state.wavesurfer.getDuration());
          const startingPosition = _.clone(this.state.pos);
          const that = this;

          (function eventLoop(that, duration) {
            setTimeout(() => {
              let currentPos = that.state.pos;
              let isPlaying = that.recordListenEvent(that.props.user, duration, currentPos);

              if (isPlaying && currentPos < duration) {
                eventLoop(that, duration);
              }
            }, 10000);
          })(that, duration, startingPosition);
        }, 100);
      }
    });
  };

  audioProcess = e => {
    const currentTime = Math.ceil(e.originalArgs && e.originalArgs[0]);
    const wavesurfer = e.wavesurfer;

    if (this.endTime && currentTime > this.endTime) {
      this.setState({ isPlaying: false });
    } else if (currentTime && Number.isInteger(currentTime) && currentTime !== this.state.pos) {
      this.setState({
        currentFormatTime: formatDuration(currentTime, true),
        totalDuration: wavesurfer.getDuration() + 1,
        pos: currentTime,
        wavesurfer: wavesurfer,
      });
    }
  };

  skip = direction => {
    if (this.state.wavesurfer) {
      if (direction === 'BACK') {
        this.state.wavesurfer.seekTo(this.secondsToPosition(this.state.pos - 15));
      } else {
        this.state.wavesurfer.seekTo(this.secondsToPosition(this.state.pos + 15));
      }
    }
  };

  secondsToPosition = sec => {
    if (this.state.wavesurfer) {
      return (1 / this.state.wavesurfer.getDuration()) * sec;
    }
  };

  getAudioPeaks = () => {
    if (!this.props.corsError && this.props.episode.audioPeaks) {
      return this.props.episode.audioPeaks;
    } else {
      if (this.props.isMobile) {
        return getFakePeaks(0.1, 0.1);
      } else {
        return getFakePeaks(0.1, 0.4);
      }
    }
  };

  renderPlayBtn = (color, isPlaying) => {
    return (
      <div className='clipp-controls'>
        <button
          className={'clipp-control-btn'}
          onClick={this.toggleAudio}
          style={{
            background: color.hex,
            color: color.isDark ? '#F5F5F5' : 'rgb(41, 30, 78)',
          }}
        >
          {this.state.isLoading ? <LoadingSpinner /> : <i className={'fa ' + (isPlaying ? 'fa-pause' : 'fa-play')} />}
        </button>
      </div>
    );
  };

  renderToggleBtn = (playerExpanded, inApp) => {
    if (!inApp) {
      return;
    }

    return (
      <div className='clipp-action-btn minimize' onClick={this.props.togglePlayer}>
        <i className={'fa fa-caret-' + (playerExpanded ? 'down' : 'up')} />
      </div>
    );
  };

  renderClipBtn = () => {
    const { user } = this.props;

    // Only render for me for now
    if (!user || (user && !user.id) || (user && user.id !== 'd9571238')) {
      return null;
    } else {
      return (
        <div className='clipp-action-btn clip' onClick={this.props.toggleAudioClipper}>
          <i className={'far fa-waveform'} />
        </div>
      );
    }
  };

  launchPopUp = e => {
    e.stopPropagation();
    const { episode } = this.props;
    window.open(
      `https://clipps.schoon.now.sh/player?id=${episode.id}`,
      `${episode.title}`,
      'width=400,height=110,left=600,top=200,personalbar=0,toolbar=0,scrollbars=0,resizable=0'
    );
  };

  renderPopUpBtn = () => {
    return (
      <a onClick={this.launchPopUp}>
        {' '}
        {/* eslint-disable-line */}
        <div className='clipp-action-btn clip'>
          <i className={'far fa-external-link'} />
        </div>
      </a>
    );
  };

  renderCounter = () => {
    return formatDuration(this.state.totalDuration);
  };

  render() {
    const { episode, show, isPlaying, pos, currentFormatTime, color, inApp, requestUpdate } = this.state;
    const { playerExpanded, isMobile } = this.props;
    const imageUrl = this.props.options.imageUrl || episode.imageUrl || show.imageUrl;
    const mobileSize = isMobile || window.innerWidth < 500;
    const embedded = this.state.embed;
    const expanded = playerExpanded || this.state.embed;
    const showUpdateEpisodeQuestion = requestUpdate;

    return (
      <div className={'clipp-container wide' + (mobileSize ? ' mobile' : '') + (embedded ? ' embedded' : '')}>
        <div className='clipp-bg' style={{ backgroundImage: `url(${imageUrl})` }} />
        <div className='clipp-shade' />
        <div className='clipp-left'>
          {expanded ? (
            <img className='clipp-img' id='clippImg' src={imageUrl} alt='clipp' />
          ) : (
            this.renderPlayBtn(color, isPlaying)
          )}
        </div>
        <div className={'clipp-content' + (mobileSize ? ' mobile' : '')}>
          {showUpdateEpisodeQuestion ? this.renderUpdateAudioQuestion() : null}
          {expanded ? (
            <React.Fragment>
              <div className='clipp-header'>
                <div
                  className='clipp-show-title'
                  onClick={() => {
                    history.push(`/${show.id}`);
                  }}
                >
                  {!mobileSize && expanded && show.title}
                </div>
                <div className={'clipp-action-btns' + (mobileSize ? ' mobile' : '')}>
                  {false && expanded && !embedded && (
                    <div className='clipp-action-btn share' onClick={this.props.shareEpisode}>
                      <i className='fa fa-share' />
                    </div>
                  )}
                  {!mobileSize && !embedded && this.renderClipBtn()}
                  {!mobileSize && !embedded && (
                    <div className='clipp-action-btn close' onClick={this.props.setActiveEpisode.bind(this, {})}>
                      <i className='far fa-times' />
                    </div>
                  )}
                </div>
              </div>
              <div className='clipp-body'>
                {this.renderPlayBtn(color, isPlaying)}
                <div className='clipp-details'>
                  <div
                    className='clipp-title'
                    onClick={() => {
                      history.push(`/e/${episode.id}`);
                    }}
                  >
                    <MultiClamp ellipsis='...' clamp={1}>
                      {episode.title}
                    </MultiClamp>
                  </div>
                  <div className='clipp-timer'>
                    <i className='fas fa-undo skip-icon' onClick={this.skip.bind(this, 'BACK')} />
                    {`${currentFormatTime} / ${this.renderCounter()}`}
                    <i className='fas fa-redo skip-icon' onClick={this.skip.bind(this, 'FORWARD')} />
                  </div>
                </div>
              </div>
            </React.Fragment>
          ) : null}
          <div className={'clipp-waves-container' + (mobileSize ? ' mobile' : '')}>
            <div className={'clipp-waves' + (!expanded ? ' mini' : '') + (mobileSize ? ' mobile' : '')}>
              {
                <ReactWaves
                  audioFile={episode.audioUrl}
                  audioPeaks={this.audioPeaks}
                  options={{
                    autoCenter: false,
                    backend: 'MediaElement',
                    barGap: mobileSize ? 0 : 2,
                    barWidth: mobileSize ? 0 : 3,
                    barHeight: mobileSize ? 10 : 2,
                    cursorWidth: 0,
                    fillParent: true,
                    height: 28,
                    hideScrollbar: true,
                    progressColor: 'rgb(255, 255, 255)',
                    responsive: true,
                    waveColor: 'rgba(255, 255, 255, 0.2)',
                  }}
                  pos={pos}
                  volume={1}
                  zoom={calculateZoom(episode.duration)}
                  playing={isPlaying}
                  onAudioprocess={this.audioProcess}
                />
              }
            </div>
            {mobileSize ? null : expanded && embedded ? (
              <div className={'clipp-permalink' + (!expanded ? ' mini' : mobileSize ? ' mobile' : '')}>
                <a href='https://clip.ps?ref=embed' target='_blank' rel='noopener noreferrer'>
                  <img className='clipp-icon' src={clippIcon} title='Clip.ps' alt='Clipps Website' />
                </a>
              </div>
            ) : (
              <div
                className={'clipp-permalink' + (!expanded ? ' mini' : mobileSize ? ' mobile' : '')}
                onClick={this.props.togglePlayer}
              >
                {this.renderToggleBtn(expanded, inApp)}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

EmbedPlayer.propTypes = {
  user: PropTypes.object,
  corsError: PropTypes.bool,
  episode: PropTypes.object,
  show: PropTypes.object,
  playerExpanded: PropTypes.bool.isRequired,
  shareEpisode: PropTypes.func.isRequired,
  setActiveEpisode: PropTypes.func.isRequired,
  setEpisodeState: PropTypes.func.isRequired,
  togglePlayer: PropTypes.func.isRequired,
  options: PropTypes.object,
  isMobile: PropTypes.bool,
};

EmbedPlayer.defaultProps = {
  user: {},
  corsError: false,
  episode: {},
  show: {},
  isMobile: false,
  options: {
    btnColor: null,
    imageUrl: null,
  },
};
